import { useState } from "react";
import { Container, Box, TextField, Button, Typography, Link } from "@mui/material";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleLogin = () => {
    console.log("ログイン:", { email, password });
    // 実際はAPI呼び出し処理
  };

  return (
    <Container maxWidth="xs" sx={{ mt: 10 }}>
      <Box
        sx={{
          border: "1px solid #ccc",
          p: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 2
        }}
      >
        <TextField
          fullWidth
          label="メールアドレス"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <TextField
          fullWidth
          label="パスワード"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <Button variant="contained" fullWidth onClick={handleLogin}>
          OK
        </Button>
        <Typography variant="body2">
          アカウントをお持ちでないですか？
          <Link href="/signup" underline="hover">
            新規登録
          </Link>
        </Typography>
      </Box>
    </Container>
  );
}
